import { render, staticRenderFns } from "./GameIdsModal.vue?vue&type=template&id=50572cde&scoped=true"
import script from "./GameIdsModal.vue?vue&type=script&lang=js"
export * from "./GameIdsModal.vue?vue&type=script&lang=js"
import style0 from "./GameIdsModal.vue?vue&type=style&index=0&id=50572cde&prod&lang=scss&scoped=true"
import style1 from "./GameIdsModal.vue?vue&type=style&index=1&id=50572cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50572cde",
  null
  
)

export default component.exports